import React, { useEffect, useState } from 'react';
import HelpBackIcon from './../../../../../images/helpbackicon.png'
import {Link, useNavigate} from 'react-router-dom'

function Performance() { 
    const [feedback,setFeedback] = useState(false)
    const navigate= useNavigate();

    return (
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundPositionX:'-1em',backgroundSize:'100%'}}>

        <div style={{         
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        zIndex:'1',
        height:'9.63em'
        }}/>

        <div style={{
              backgroundColor:'#F9FCFF',
              width:'100%',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              paddingBottom:'5.5em',
              minHeight: '72vh', height: 'auto'
        }}>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'flex-start',
                width:'70%',
                paddingTop:'2.5em'
            }}>

                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    cursor:'pointer'
                   
                }} onClick={()=>{navigate("/help");setFeedback(false)}}>
                    <img src={HelpBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em',cursor:'pointer'}}/>
                    <div className="backTxt">Back</div>
                </div>

                <div className="infoHeader">
                    Performance Tips
                </div>

                <div className="infoDesc">
                Performance tips based on music distribution data analytics are actionable recommendations designed to help artists, record labels, and music industry professionals maximize their music’s reach, engagement, and revenue. By leveraging insights from detailed analytics, these tips focus on optimizing various aspects of music distribution and marketing strategies.
                </div>

                <div style={{display:'flex',flexDirection:'row'}}>
                <div className="infoDesc" style={{marginRight:'0.5em',marginLeft:'0.2em'}}>
                &nbsp;1.
                </div>
                <div className="infoDesc">
                <span style={{fontWeight:'500'}}>Optimize Release Timing:</span> &nbsp;Analyze data to identify when your audience is most active and receptive to new music. By aligning your release schedule with peak listening times, you can increase the chances of higher initial streams and downloads.
                </div>
                </div>

                <div style={{display:'flex',flexDirection:'row'}}>
                <div className="infoDesc" style={{marginRight:'0.5em',marginLeft:'0.2em'}}>
                &nbsp;2.
                </div>
                <div className="infoDesc">
                <span style={{fontWeight:'500'}}>Target Key Markets:</span> &nbsp;Use geographic data to focus your promotional efforts on regions where your music is gaining traction. Tailor marketing campaigns, tour dates, and merchandise offerings to resonate with these high-engagement areas, further boosting your presence.
                </div>
                </div>

                <div style={{display:'flex',flexDirection:'row'}}>
                <div className="infoDesc" style={{marginRight:'0.5em',marginLeft:'0.2em'}}>
                &nbsp;3.
                </div>
                <div className="infoDesc">
                <span style={{fontWeight:'500'}}>Leverage Playlist Opportunities: </span> &nbsp; Monitor playlist placements and identify trends in which playlists generate the most streams for your tracks. Focus on pitching your music to curators of similar playlists or those with overlapping audiences to expand your reach.
                </div>
                </div>

                <div style={{display:'flex',flexDirection:'row'}}>
                <div className="infoDesc" style={{marginRight:'0.5em',marginLeft:'0.2em'}}>
                &nbsp;4.
                </div>
                <div className="infoDesc">
                <span style={{fontWeight:'500'}}>Engage with Your Core Audience:</span> &nbsp;Utilize listener demographics to better understand who your most dedicated fans are. Create targeted content, such as exclusive releases, social media interactions, or fan meetups, to strengthen your relationship with this core group.
                </div>
                </div>

                <div style={{display:'flex',flexDirection:'row'}}>
                <div className="infoDesc" style={{marginRight:'0.5em',marginLeft:'0.2em'}}>
                &nbsp;5.
                </div>
                <div className="infoDesc">
                <span style={{fontWeight:'500'}}>Refine Your Marketing Strategy: </span> &nbsp;Analyze the performance of past marketing campaigns to see what worked and what didn’t. Use this information to refine your approach, doubling down on successful tactics while adjusting or eliminating less effective ones.
                </div>
                </div>

                <div style={{display:'flex',flexDirection:'row'}}>
                <div className="infoDesc" style={{marginRight:'0.5em',marginLeft:'0.2em'}}>
                &nbsp;6.
                </div>
                <div className="infoDesc">
                <span style={{fontWeight:'500'}}>Experiment with Release Formats: </span> &nbsp;Test different formats, such as singles, EPs, or albums, to see which resonates best with your audience. Use data on stream counts and downloads to determine the most effective format for maximizing engagement and revenue.
                </div>
                </div>

                <div style={{display:'flex',flexDirection:'row'}}>
                <div className="infoDesc" style={{marginRight:'0.5em',marginLeft:'0.2em'}}>
                &nbsp;7.
                </div>
                <div className="infoDesc">
                <span style={{fontWeight:'500'}}>Monitor and Adapt to Trends:</span> &nbsp;Keep an eye on the latest trends in the music industry, such as emerging genres, popular themes, or new platforms. Use your analytics data to see how these trends align with your audience’s preferences, and adapt your music and marketing strategies accordingly.
                </div>
                </div>

                <div style={{display:'flex',flexDirection:'row'}}>
                <div className="infoDesc" style={{marginRight:'0.5em',marginLeft:'0.2em'}}>
                &nbsp;8.
                </div>
                <div className="infoDesc">
                <span style={{fontWeight:'500'}}>Maximize Revenue Streams:</span> &nbsp;Track your revenue sources to identify which platforms or methods are most profitable. Consider focusing more on these avenues or exploring new ways to monetize your music, such as sync licensing, merchandise, or fan subscriptions.
                </div>
                </div>

                <div style={{display:'flex',flexDirection:'row'}}>
                <div className="infoDesc" style={{marginRight:'0.5em',marginLeft:'0.2em'}}>
                &nbsp;9.
                </div>
                <div className="infoDesc">
                <span style={{fontWeight:'500'}}>Collaborate Strategically:</span> &nbsp;Analyze the impact of past collaborations on your music’s performance. Use this data to identify potential collaborators who could help you tap into new audiences or boost your presence on specific platforms.
                </div>
                </div>

                <div style={{display:'flex',flexDirection:'row'}}>
                <div className="infoDesc" style={{marginRight:'0.5em',marginLeft:'0.2em'}}>
                &nbsp;10.
                </div>
                <div className="infoDesc">
                <span style={{fontWeight:'500'}}>Continuously Review and Adjust:</span> &nbsp;Regularly review your analytics data to stay informed about how your music is performing. Use these insights to make ongoing adjustments to your distribution and marketing strategies, ensuring that you remain agile and responsive to changes in the music landscape.
                </div>
                </div>

                <div className="infoDesc">
                By implementing these performance tips, grounded in robust data analytics, you can enhance your music’s impact, grow your fanbase, and increase your earnings in a competitive industry.
                </div>

                {
                    !feedback &&
                    <div>
                         <div className="infoDesc" style={{marginTop:'6.5em'}}>
                            Was this article helpful?
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    YES
                                </div>

                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    NO
                                </div>
                            </div>
                    </div>
                }

                {
                    feedback &&
                    
                         <div className="infoDesc" style={{marginTop:'8.5em'}}>
                           Thank you for your feedback
                            </div>

                         
                    
                }
               
            </div>

        </div>
        
        
       
    </div>
    )
}


export default Performance;